import React,{useState} from 'react';
import './product_audit.css';
import Trial from '../Trial';

export default function Productoverview() {
    const overviewData = [
        {
            imgSrc: '../../../../images/overview1.png',
            title: 'Accounting, Inventory & e-Invoicing – Simplified',
            description: 'Our all-in-one billing platform integrates Accounting, Inventory, and e-Invoicing to streamline operations. Automate invoices, track payments, manage stock, and boost profitability—effortlessly.'
        },
        {
            imgSrc: '../../../../images/overview2.png',
            title: 'Integrated GST Reporting System',
            description: 'File accurate GST returns with ease using our intelligent reporting suite. Access GSTR-1, GSTR-3B, and more—validated in real time. Reduce errors, save time, and stay fully compliant.'
        },
        {
            imgSrc: '../../../../images/overview3.png',
            title: 'Import & Export Data',
            description: 'Our software simplifies the process of importing and exporting data, allowing you to seamlessly transfer information to and from various sources. Whether you need to migrate data from existing systems, collaborate with external partners, or maintain backups, our import and export functionality streamlines the entire process'
        },
        {
            imgSrc: '../../../../images/overview4.png',
            title: 'Manage Your Business Efficiently, Wherever You Are',
            description: 'Manage your business efficiently from anywhere with the power of modern tools and technology. Stay connected, monitor performance, and make smart decisions on the go—whether you are at the office, at home, or traveling.With real- time access to data and seamless communication, running your business remotely has never been easier.'
        },
    ];
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqData = [
        {
            question: 'What is Auditusierp?',
            answer: 'Auditusierp is an all-in-one ERP platform for accounting, inventory, GST, and business reporting.'
        },
        {
            question: 'Can I access Auditusierp remotely?',
            answer: 'Yes, it is cloud-based and accessible from any device with an internet connection.'
        },
        {
            question: 'Is Auditusierp GST compliant?',
            answer: 'Absolutely. It supports real-time GST filing, including GSTR-1, GSTR-3B, and more.'
        },
        {
            question: 'How does Auditusierp handle data import/export?',
            answer: 'It allows seamless data migration and supports bulk import/export to Excel and other formats.'
        },
        {
            question: 'Can I manage multiple companies in Auditusierp?',
            answer: 'Yes, it supports multi-company and multi-user environments with role-based permissions.'
        },
        {
            question: 'Does Auditusierp offer inventory management?',
            answer: 'Yes, it provides live inventory tracking, stock alerts, and barcode scanning support.'
        },
        {
            question: 'Is there a mobile app for Auditusierp?',
            answer: 'Yes, mobile apps are available for both Android and iOS, offering real-time access on the go.'
        },
        {
            question: 'How customizable is Auditusierp?',
            answer: 'It includes customizable invoice formats, report templates, and user-defined settings.'
        },
        {
            question: 'What kind of support is available?',
            answer: 'You get email, chat, and phone support, along with training and onboarding help.'
        },
        {
            question: 'Is my data safe in Auditusierp?',
            answer: 'Yes, your data is encrypted, regularly backed up, and hosted on secure servers.'
        }
    ];
    

    return (
        <div className="product-overview-container">
            <div className="hero-content">
                <div className="text-section">
                    <h1>All-in-One, All for You Meet Auditusierp</h1>
                    <p>
                        From managing books to filing GST returns, tracking inventory to<br />
                        generating insightful reports—Auditusierp is your all-in-one<br />
                        growth partner.
                    </p>
                </div>
                <div className="image-section">
                    <img src='../../../../images/Product_overview.jpg' alt="Auditusierp Overview" />
                </div>
            </div>
         
            <div className="image-row">
                <img src='../../../../images/overview_ban_1.png' className='divider-img' />
                <img src='../../../../images/overview_ban_2.png' className='divider-img' />
            </div>

                <div className="overview-grid">
                    {overviewData.map((item, index) => (
                        <div className="overview-card" key={index}>
                            <img src={item.imgSrc} className="card-img" />
                            <div className="card-content">
                                <h2>{item.title}</h2>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
           </div>
            <div className="faq-section">
                <h2 className="faq-title">Frequently Asked Questions</h2>
                {faqData.map((item, index) => (
                    <div className="accordion-item" key={index}>
                        <div
                            className={`accordion-question ${openIndex === index ? 'active' : ''}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            {item.question}
                        </div>
                        <div className={`accordion-answer ${openIndex === index ? 'show' : ''}`}>
                            <p>{item.answer}</p>
                        </div>
                    </div>
                ))}
            </div>
            <Trial/>
        </div>
    );
}
